import { gameState } from "appworks/model/game-state";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { TumbleRecord } from "slotworks/model/gameplay/records/tumble-record";

export class InFreespinsDecision extends Decision {
    public evaluate() {
        // TODO: can't this whole function just be: return gameState.getCurrentGame().inFreespins() ? Exit.True : Exit.False;

        let record = gameState.getCurrentGame().getCurrentRecord();

        if (!(record instanceof FreespinRecord) && record.lastChild) {
            if (record.parent) {
                record = record.parent;
            }
        }

        // TODO: should probably rethink how we use record types to determine if we're in freespins or not - this is a bit of a hack
        if (record instanceof TumbleRecord) {
            if (record.parent) {
                record = record.parent;
            }
        }

        return record instanceof FreespinRecord ? Exit.True : Exit.False;
    }
}
